module.exports = __webpack_public_path__ + "img/qrcode-ycsyb_258.bac602e4.jpg";